import React from 'react';
import {Link,NavLink} from 'react-router-dom';

const Contact=()=>{
return(

<div>
	<nav className="ui raised very padded segment">
	<span style={{fontSize:'25px'}} ><Link to="/">Asfak Ahmed</Link></span>
	<div className="ui right floated header">
		<Link to="/About"><button className="ui button">About</button></Link>
		<NavLink to="/Projects"><button className="ui button">Projects</button></NavLink>
		<NavLink to="/Contact"><button className="ui yellow button">Contact</button></NavLink>
	</div>
	</nav>
	
   <div className="ui raised very padded text container segment"style={{marginTop:'80px'}}>
	<Link  to='/card/Phone' ><p style={{textAlign:'center'}} className='ui text segment' >Click for Phone no.</p></Link>
	<Link to='/card/Email'><p style={{textAlign:'center'}} className='ui text segment' >Click for Email</p></Link>
   </div>	
</div>
)
}
export default Contact;